"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getShouldAllowUploads = void 0;

var _Constants = require("FileManagerLib/Constants");

var getShouldAllowUploads = function getShouldAllowUploads(paramters) {
  var type = paramters.type,
      hasUserExceededVideoLimit = paramters.hasUserExceededVideoLimit;

  switch (type) {
    case _Constants.DrawerTypes.HUBL_VIDEO:
      return !hasUserExceededVideoLimit;

    default:
      return true;
  }
};

exports.getShouldAllowUploads = getShouldAllowUploads;